export enum ActionType {
	UPDATE_PROGRESS_VALUE = "main/UPDATE_PROGRESS_VALUE",
	TOGGLE_PROGRESS = "main/TOGGLE_PROGRESS",
	SET_ERROR = "main/SET_ERROR",
	RESET_ERROR = "main/RESET_ERROR",
	CHECK_AGREEMENT = "main/CHECK_AGREEMENT",
	TEXT_INPUT_CHANGE = "main/TEXT_INPUT_CHANGE",
	TOGGLE_PRELOADER = "main/TOGGLE_PRELOADER",
	SHOW_ERROR = "main/SHOW_ERROR",
	ADD_PHONE = "main/ADD_PHONE",
	SET_INITIAL_PAGE_INDEX = "main/SET_INITIAL_PAGE_INDEX",
	SET_QUIZ_WAS_OPENED = "main/SET_QUIZ_WAS_OPENED"
}